import RpcService from "@/core/services/Rpc/RpcService";
import RpcResponse from "@/core/services/Rpc/RpcResponse";
import PaymentReasonBasis from "@/domains/PaymentRequests/PaymentReasonBasis";
import ProductionSite from "@/domains/ProductionSites/ProductionSite";

/**
 * DAO для назначений платежа (oracle.tehno_fin_payment_destination)
 */
class SWPaymentDestinationsDAO {

    /**
     * Загружает список назначений платежа
     */
    static async getList(
      filters: {
        paymentReasonBasis: PaymentReasonBasis,
        productionSite: ProductionSite
      }
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('sWPaymentDestinations.getList', {
            paymentReasonBasis: { id: filters.paymentReasonBasis.id },
            productionSite:     { id: filters.productionSite.id },
        });
    }
}

export default SWPaymentDestinationsDAO;
